import { Mesh, Color, Clock, Vector3, MeshBasicMaterial, SphereGeometry } from 'three'
import BaseHierarchicalObject from '../BaseHierarchicalObject'
export default class FireworkComponent extends BaseHierarchicalObject {
  constructor (inColor = new Color(1.0, 1.0, 1.0)) {
    super()
    this.init()
    // var fsm = new FireworkShaderMaterial()
    // var material = fsm.getMaterial(inColor)
    this.color = inColor
    this.intensity = 0.7
    var material = new MeshBasicMaterial({ color: inColor })
    this.oShell = new Mesh(this.geometry, material)
    this.oShell.position.set(0, 5, 0)
    this.velocity = new Vector3(0, 0, 0)
    this.acceleration = new Vector3(0, -4.8, 0)
    this.add(this.oShell)
  }
  init () {
    this.clock = new Clock()
    this.fuse = 3.0 - Math.random() * 0.6
    this.lastTime = 0
    this.name = 'firework_component'
    this.geometry = new SphereGeometry(0.1, 8, 8)
  }
  update (timeStamp) {
    super.update(timeStamp)
    if (this.clock.getElapsedTime() > this.fuse)
    { this._parent.removeChild(this) }

    this.lastTime = timeStamp
    var translate = this.velocity.clone().multiplyScalar(this.delta)
    var dV = this.acceleration.clone().multiplyScalar(this.delta)
    // console.log(translate)
    this.velocity.add(dV)
    this.oShell.position.add(translate)
  }
  getFireworkData () {
    if (this.oShell != null) {
      return {
        position: this.oShell.position,
        color: this.color,
        intensity: this.intensity
      }
    }
  }
  setVelocity (inVelocity) {
    this.velocity.copy(inVelocity)
  }
  setPosition (inPosition) {
    this.oShell.position.copy(inPosition)
  }
}
